// Documents Block Component
import React, { useState } from 'react';
import { FileText } from 'lucide-react';

const DocumentsBlock = ({ content, padding, backgroundColor, onUpdate }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [category, setCategory] = useState(content?.category || '');
  const [allowDownload, setAllowDownload] = useState(content?.allowDownload !== false);

  const handleSave = () => {
    onUpdate({ content: { category, allowDownload } });
    setIsEditing(false);
  };

  const getPaddingClass = () => {
    switch (padding) {
      case 'none': return 'p-0';
      case 'small': return 'p-4';
      case 'large': return 'p-12';
      default: return 'p-8';
    }
  };

  if (isEditing) {
    return (
      <div className={getPaddingClass()} style={{ backgroundColor }}>
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-[#3C3C3C] dark:text-gray-100 mb-2">
              Category (optional)
            </label>
            <input
              type="text"
              value={category}
              onChange={(e) => setCategory(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded bg-white dark:bg-gray-700 text-[#3C3C3C] dark:text-gray-100"
              placeholder="Leave blank for all"
            />
          </div>

          <div>
            <label className="flex items-center gap-2">
              <input
                type="checkbox"
                checked={allowDownload}
                onChange={(e) => setAllowDownload(e.target.checked)}
                className="rounded border-gray-300 dark:border-gray-600"
              />
              <span className="text-sm text-[#3C3C3C] dark:text-gray-100">
                Allow downloads
              </span>
            </label>
          </div>

          <div className="flex gap-2">
            <button onClick={handleSave} className="px-4 py-2 bg-[#7A99D8] text-white rounded hover:bg-[#6A89C8]">Save</button>
            <button onClick={() => setIsEditing(false)} className="px-4 py-2 border border-gray-300 dark:border-gray-600 rounded text-[#3C3C3C] dark:text-gray-100 hover:bg-gray-50 dark:hover:bg-gray-700">Cancel</button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={getPaddingClass()} style={{ backgroundColor }}>
      <div className="text-center">
        <FileText className="w-12 h-12 text-[#7A99D8] mx-auto mb-4" />
        <h3 className="text-lg font-semibold text-[#3C3C3C] dark:text-gray-100 mb-2">Documents</h3>
        <p className="text-sm text-gray-600 dark:text-gray-400">{category || 'All documents'}</p>
      </div>
    </div>
  );
};

export default DocumentsBlock;
